import { render, staticRenderFns } from "./MyAgreement.vue?vue&type=template&id=86c2265c"
import script from "./MyAgreement.vue?vue&type=script&lang=js"
export * from "./MyAgreement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports